import React from 'react';
import { useSelector } from "react-redux";
import levarLogo from '../../assets/images/loading/levAR_logo.svg'; // white

const LevarLogo = (props) => {

  const { settings } = useSelector(state => ({
    settings: state.settings,
  }));

  return (
    <div className="LevarLogo">
      <a href={ settings.home_url ? settings.home_url : "https://www.levar.io/home?utm_source=levar&utm_medium=viewer&utm_campaign=viewer1" } target="_blank" rel="noopener noreferrer">
        <img src={ settings.logo_file ? settings.logo_file : levarLogo } alt="Company Logo"/>
      </a>
    </div>
  )
}

export default LevarLogo;
